"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Algorithm = void 0;
/**
 * @see    [Linkedin] {@link https://www.linkedin.com/in/samuel-hinchliffe-2bb5801a5/}
 *
 * @summary Native browser crypto modules only support the enum below.
 * Created at: 26/06/2024
*/
var Algorithm;
(function (Algorithm) {
    Algorithm["SHA1"] = "SHA-1";
    Algorithm["SHA256"] = "SHA-256";
    Algorithm["SHA384"] = "SHA-384";
    Algorithm["SHA512"] = "SHA-512";
})(Algorithm = exports.Algorithm || (exports.Algorithm = {}));
